// src/store/sidebar/sidebarReducer.js

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
}

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'set':
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default sidebarReducer
